<template>
	<div :class="['trick-wrapper', { owned, selected }]">
		<Vector class="icon" :src="icon" contain="width" />
		<div class="content">
			<div class="title">{{ title }}</div>
			<div class="cost">{{ costString }}</div>
			<ScoreModifier class="score-modifier-wrapper" v-bind="$attrs" />
		</div>
	</div>
</template>

<script>
import { currencyFormatter } from "@/lib/formatters";
import ScoreModifier from '@/components/game/shop/ScoreModifier';
import Vector from '@/components/base/Vector';

export default {
	name: 'Trick',
	components: {
		ScoreModifier,
		Vector,
	},
	props: {
		id: {
			type: Number,
			required: true,
		},
		icon: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		cost: {
			type: Number,
			required: true,
		},
		owned: {
			type: Boolean,
			required: true,
		},
		selected: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		formattedCost() {
			return currencyFormatter.format(this.cost);
		},
		costString() {
			return this.owned ? "owned" : `${this.formattedCost}`;
		},
	},
};
</script>

<style lang="scss" scoped>
	.trick-wrapper {
		cursor: pointer;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 100%;
		padding: 20px;
		background: $alt-color;

		@include mobile { padding: 5%; }
		@include desktop-sm { padding: 15px; }

		&.selected { background: $alt-color-dark; }
		&.owned { background: $primary-color-dark; }
	}

	.icon {
		display: inherit;
		max-width: 35%;
		max-height: 100%;

		@include tablet { max-width: 32%; }
		@include desktop { max-width: 35%; }
	}

	.content {
		flex: 0 0 60%;
		color: $body-txt-color;
		text-align: right;
	}

	.title {
		white-space: nowrap;
		text-align: right;
		font-family: $body-font-script;
		font-size: $font-size-xx-lg;
		line-height: $line-height-snug;

		@include mobile { font-size: $font-size-lg; }
	}

	.cost {
		font-size: $font-size-x-lg;
		text-transform: uppercase;

		@include mobile { font-size: $font-size-base; }

		.owned & { color: $off-white; }
	}

	.score-modifier-wrapper {
		width: 75%;
		float: right;

		@include mobile { display: none; }
	}
</style>



// WEBPACK FOOTER //
// src/components/game/shop/TrickDetail.vue